import { render, staticRenderFns } from "./CustomRedSelect.vue?vue&type=template&id=bb808048&scoped=true&"
import script from "./CustomRedSelect.vue?vue&type=script&lang=js&"
export * from "./CustomRedSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomRedSelect.vue?vue&type=style&index=0&id=bb808048&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb808048",
  null
  
)

export default component.exports